// Report registry — maps report slugs to their config file names.
// The actual config JSON is loaded from the API at runtime.
// Adding a new report: just add one line here + nav entry in navigationConfig.js.

const reportRegistry = {
  'slugRptStd-Gen-IO_Assignments': {
    configId: 'slugRptStd-Gen-IO_Assignments',
    label: 'I/O Assignments',
    description: 'Tag IO assignment details by panel, drop, slot, channel'
  },
  'slugRptStd-Gen-Drawing_Log': {
    configId: 'slugRptStd-Gen-Drawing_Log',
    label: 'Drawing Log',
    description: 'Drawing revision history by source and drawing name'
  },
  'slugRptStd-Net-IP_Addresses_Device_Level': {
    configId: 'slugRptStd-Net-IP_Addresses_Device_Level',
    label: 'IP Addresses - DLN',
    description: 'Dynamic LAN device IP address assignments'
  },
  'slugRptStd-Net-IP_Addresses_Site_Level': {
    configId: 'slugRptStd-Net-IP_Addresses_Site_Level',
    label: 'IP Addresses - SLN',
    description: 'Secure LAN device IP address assignments'
  },
  'slugRptStd-Net-Network_Connections': {
    configId: 'slugRptStd-Net-Network_Connections',
    label: 'Network Connection Report',
    description: 'ENET network connections by equipment, panel, and port'
  },
  'slugRptStd-Gen-Panel_Report': {
    configId: 'slugRptStd-Gen-Panel_Report',
    label: 'Panel Report',
    description: 'Tag IO assignments by panel, drop, slot, and channel'
  },
  'slugRptStd-Cx-OAT_Report': {
    configId: 'slugRptStd-Cx-OAT_Report',
    label: 'OAT Report',
    description: 'Owner Acceptance Testing status by tag'
  },
  'slugRptStd-Cx-Panel_QAQC_Report': {
    configId: 'slugRptStd-Cx-Panel_QAQC_Report',
    label: 'QAQC Report',
    description: 'Construction QA/QC status by tag'
  },
  'slugRptStd-Cx-Commissioning_Status': {
    configId: 'slugRptStd-Cx-Commissioning_Status',
    label: 'Commissioning Status Report',
    description: 'Full commissioning status including construction and OAT by tag'
  },
  'slugRptStd-Sub-Index_Report_Panels': {
    configId: 'slugRptStd-Sub-Index_Report_Panels',
    label: 'Index Report - Panels',
    description: 'Index sheet specifications for panels'
  },
  'slugRptStd-Sub-Index_Report_Tags': {
    configId: 'slugRptStd-Sub-Index_Report_Tags',
    label: 'Index Report - Tags',
    description: 'Index sheet specifications for tags'
  }
};

export default reportRegistry;

export const getReportMeta = (slug) => reportRegistry[slug] || null;

export const getAllReports = () =>
  Object.entries(reportRegistry).map(([slug, meta]) => ({ slug, ...meta }));
